// extracted by css-extract-rspack-plugin
export default {"cls1":"LearningPoints-cls1_E5T","cls2":"LearningPoints-cls2__GP LearningPoints-cls1_E5T"};